import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
  } from '@material-ui/core';
  import React, { useState } from 'react';
  import * as S from './styles';
  import { AnchorSelectBox } from '../../../../components/AnchorSelectBox';
  
  function AnchorsLogoOptions({ anchors, handleSelectAnchor, selectedAnchor }) {
    const [open, setOpen] = useState(false);
    const [newSelectedAnchor, setNewSelectedAnchor] = useState({});
    const [anchorsModal, setAnchorsModal] = useState({
      show: false,
      callback: () => {},
      anchors: [],
      newSelectedAnchor: {},
      closeModal: () => {}
    })

    const handleSelecteAnchor = (anchor) => {
      setNewSelectedAnchor(anchor);
      handleSelectAnchor(anchor);
      closeModal()
    }

    const closeModal = () => {
      setAnchorsModal({
        show: false,
        callback: () => {},
        anchors: [],
        newSelectedAnchor: {},
        closeModal: () => {}
      })
    }

    return (
      <>
        <S.MetasBox>
          <S.TableTitleHeader>
            <h3 className="operation-title text-center">Plataformas/Redes</h3>
          </S.TableTitleHeader>
          <S.MetasContainer>
            <S.AnchorLogo onClick={() => {
              if (anchors.redes.length > 0
                || anchors.redeCapittale.ancoraId
                || anchors.plataformas.length > 0
                || anchors.length > 0) {

              }
              setAnchorsModal({
                show: true,
                callback: handleSelecteAnchor,
                anchors: anchors,
                newSelectedAnchor: selectedAnchor,
                closeModal: closeModal
              })
            }}>
              {selectedAnchor?.logotipoLink ? (
                <img
                style={{ objectFit: 'contain', background: 'white' }}
                src={selectedAnchor?.logotipoLink}
                alt={`Logo da rede ${selectedAnchor?.nomeFantasia ? selectedAnchor?.nomeFantasia : selectedAnchor?.plataforma}`}
              />
              ) : (
                <div style={{cursor: 'pointer'}}>
                {selectedAnchor?.nomeFantasia ? selectedAnchor?.nomeFantasia : selectedAnchor?.plataforma}
                </div>
              )}
            </S.AnchorLogo>
          </S.MetasContainer>
        </S.MetasBox>
        {anchorsModal.show && (
          <AnchorSelectBox
            data={anchorsModal}
          ></AnchorSelectBox>
        )}
      </>
    );
  }
  
  export default AnchorsLogoOptions;
  